import React, { Component } from "react";
import { MLSStats } from "./react-mlsdata";
import MarketTrends from "./MarketTrends";
import {uniqueId} from 'lodash';

import cache from "memory-cache";


export default class MTWidget extends Component {
   constructor(props) {
    super(props);
   }
   componentDidMount(){
    
      if(userPrefFetched === false){
        document.body.dispatchEvent(acculistFetch)
      }
  }
  render() {         
    var filter,orderBy ='';
    const {assets,widgetselections} = {...this.props};
    const Children = this.props.children;
    const {measure,period,periodtype,geo,classtype}={...widgetselections}; 
    var cdate=new Date(); 
   
    // localStorage['userpreferences4'] = JSON.stringify(assets);
    // localStorage.setItem("userpreferences4", JSON.stringify(assets));

    window.userpreferStore = assets;

    var geofilter=[];
    geo.forEach(function(geo){
    var g1=geo.split(':')[0];
    var g2=geo.split(':')[1];
   
    //Changes to accomodate the AreaID search
    let geoquery=(g1.toLowerCase()=='area' && !isNaN(g2)) ?{ and: [{ GeographyType: `${g1}` }, { AreaId: Number(g2) }] }:{ and: [{ GeographyType: `${g1}` }, { GeographyName: `${encodeURIComponent(g2)}` }] };
    //let geoquery={ and: [{ GeographyType: `${g1}` }, { GeographyName: `${encodeURIComponent(g2)}` }] }
    geofilter.push(geoquery);

    })

var classtypefilter=classtype.split(',');
/*  classtypefilter.forEach(function(ct){
  let ctquery={ or: [{ GeographyType: `${g1}` }, { GeographyName: `${g2}` }] }  
})  */






   if(periodtype.toLowerCase()=='year'){ 
     let setperiod=(cdate.getFullYear()-period+1);  
     filter ={and:[[{Class : {'in':classtypefilter}}],{PeriodType : periodtype},{Period: {ge:`${setperiod}`}}, { or: geofilter } ]} ; 
   
   } else

   if(periodtype.toLowerCase()=='month'){   
     var months = [];    
             var monthnames={0:'01',1:'02',2:'03',3:'04',4:'05',5:'06',6:'07',7:'08',8:'09',9:'10',10:'11',11:'12'};
            for(var i = 0; i < period; i++) {
                months.push(cdate.getFullYear()+'-'+monthnames[cdate.getMonth()] );
                cdate.setMonth(cdate.getMonth() - 1);
            }    
    
    
         filter ={and:[[{Class : {'in':classtypefilter}}],{PeriodType : periodtype},[{Period: {'in': months}}], { or: geofilter } ]} ; 
 
   } else

   if(periodtype.toLowerCase()=='quarter'){
   var thisYear = cdate.getFullYear();
   var quarterStart = Math.ceil((cdate.getMonth() + 1) / 3);
  var quarters = []; 
   for (var i = 0; i < period; i++) {
quarters.push(thisYear+'Q' + quarterStart );
    quarterStart--;
    if (quarterStart <= 0) {
        thisYear--;
        quarterStart = 4;
    };
         
     filter ={and:[[{Class : {'in':classtypefilter}}],{PeriodType : periodtype},[{Period: {'in': quarters}}], { or: geofilter } ]} ; 
   //  filter ={and:[{GeographyType: `${geographytype}`}, { GeographyName:`${geographyvalue}`},{Class : 'Residential'},{PeriodType : periodtype},[{Period: {'in': quarters}}]] } ; 

 
   }
   }

   orderBy=['PeriodValue'+' desc'];


     var chart_id='chart_'+_.uniqueId();
    
     
     var widget= period==''?'': (

       <MLSStats collection='MarketTrendsYTDExpanded_KPI' filter={filter} orderBy={orderBy} >
        {({ loading, error, data }) => (         
          <div className={`markettrends ${loading ? "loading" : ""}`}>
            {loading && <div className="loader msg pos-absolute">Loading...</div>}
            {error && <h2>{console.log(`${error}`)}System error in widgets. Please contact system administrator.</h2>}
            {data && <div className="chart-body"><MarketTrends {...this.props} id={chart_id} assets={assets} widgetselections={widgetselections} data={data.value}>{Children}</MarketTrends></div>}
          </div>
        )}
      </MLSStats>       
     );

    return <div> {widget} </div>;    
  }
}





// WEBPACK FOOTER //
// ./src/index.js